'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { createElement as _createElement } from "react";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var _class, _temp;

import { Fragment, Component } from 'react';
import { findDOMNode } from 'react-dom';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import emptyFunction from 'react-utils/emptyFunction';
import styled from 'styled-components';
import PortalIdParser from 'PortalIdParser';
import { BUTTON_DISABLED_TEXT, EERIE, OBSIDIAN } from 'HubStyleTokens/colors';
import Draggable from 'UIComponents/draggable/utils/Draggable';
import UIFolderNavItem from 'UIComponents/nav/UIFolderNavItem';
import * as FoldersActions from 'DesignData/actions/finder/Folders';
import * as SelectionsActions from 'DesignData/actions/finder/Selections';
import { setActiveThemeFolderId } from 'DesignData/actions/finder/Themes';
import { setActiveProjectFolderId } from 'DesignData/actions/finder/Projects';
import * as FolderSubcategories from 'DesignData/enums/FolderSubcategories';
import { hasShiftKey, hasCommandKey } from 'DesignData/enums/Keys';
import { HUBSPOT_FOLDER_ID, MARKETPLACE_FOLDER_NAME } from 'DesignData/constants/Folders';
import * as FinderPropTypes from 'DesignData/propTypes/finder';
import * as finderSelectors from 'DesignData/selectors/finder';
import { folderDragSource, folderDropTarget } from 'DesignFinderUI/components/dnd/FolderDragDrop';
import FolderIcon from 'DesignComponents/icons/FolderIcon';
import FolderTitle from 'DesignFinderUI/components/nav/FolderTitle';
import FileNode from 'DesignFinderUI/components/nav/FileNode';
import FileUploadNode from 'DesignFinderUI/components/nav/FileUploadNode';
import withConnectedFolder from 'DesignFinderUI/hocs/withConnectedFolder';
import { compose } from 'redux';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';

const i18nKey = key => `DesignFinderUI.actions.ProjectToolTip.${key}`;

const UneditableIcon = styled(UIIcon).withConfig({
  displayName: "FolderNode__UneditableIcon",
  componentId: "sc-4t95j5-0"
})(["margin-left:auto;"]);
const {
  FolderPropTypes
} = FinderPropTypes;
const DraggableFolderNavItem = Draggable(UIFolderNavItem);
const DRAG_OVER_TIMEOUT = 2000;

const makeMapStateToProps = () => {
  const getIsFetchingFolderContents = finderSelectors.makeGetIsFetchingFolderContents();
  const getFetchFolderContentsError = finderSelectors.makeGetFetchFolderContentsError();
  const getFolderOpenState = finderSelectors.makeGetFolderOpenState();
  const getFolderContentsOrder = finderSelectors.makeGetFolderContentsOrder();
  const getBulkPermissions = finderSelectors.makeGetAssetBulkPermissions();
  const getCanMoveSelectedAssets = finderSelectors.makeGetCanMoveSelectedAssets();
  const getFolderContents = finderSelectors.makeGetFolderContents();
  return (state, ownProps) => {
    const {
      folderSubcategory,
      folderId,
      folderName
    } = ownProps;
    const {
      showRenameFolderConfirm
    } = finderSelectors.getSavedOptions(state);
    const revealedAssetId = finderSelectors.getRevealedAssetId(state);
    return {
      bulkPermissions: getBulkPermissions(state, ownProps),
      canMoveSelectedAssets: getCanMoveSelectedAssets(state, ownProps),
      fetchContentsError: getFetchFolderContentsError(state, ownProps),
      folderContents: getFolderContents(state, ownProps),
      folderContentsOrder: getFolderContentsOrder(state, ownProps),
      initialOpen: getFolderOpenState(state, ownProps),
      isFetchingContents: getIsFetchingFolderContents(state, ownProps),
      isHubspotRootFolder: folderId === HUBSPOT_FOLDER_ID,
      isMarketplaceRootFolder: folderName === MARKETPLACE_FOLDER_NAME,
      isRootFolder: folderSubcategory === FolderSubcategories.DESIGN_ROOT,
      isRevealedAsset: revealedAssetId === folderId,
      isThemeFolder: finderSelectors.getIsThemeRootFolder(state, ownProps),
      showRenameFolderConfirm,
      isLocked: finderSelectors.getIsLocked(state, ownProps),
      activeThemeFolderId: finderSelectors.getActiveThemeFolderId(state),
      activeProjectFolderId: finderSelectors.getActiveProjectFolderId(state),
      evaluateIsThemeRootFolder: finderSelectors.getEvaluateIsThemeRootFolder(state),
      isServerlessFunctionFolder: finderSelectors.getIsServerlessFunctionFolder(state, ownProps),
      isProjectFolder: finderSelectors.getIsProjectsFolder(state, ownProps)
    };
  };
};

const mapDispatchToProps = {
  fetchContents: FoldersActions.fetchContents,
  moveContents: FoldersActions.moveContents,
  moveSelectedAssets: FoldersActions.moveSelectedAssets,
  selectFolder: SelectionsActions.selectFolder,
  toggleOpenFolder: FoldersActions.toggleOpenFolder,
  shiftSelectAsset: SelectionsActions.shiftSelectAsset,
  revealInFinder: SelectionsActions.revealInFinder,
  setActiveThemeFolderId,
  setActiveProjectFolderId
};
const FolderNode = compose(withConnectedFolder, connect(makeMapStateToProps, mapDispatchToProps), folderDragSource, folderDropTarget)((_temp = _class = class extends Component {
  constructor(..._args) {
    super(..._args);
    this.state = {
      open: this.props.initialOpen
    };

    this.handleSelectFolder = (isMultiselect = false) => {
      const {
        folderId,
        parentFolderId,
        selectFolder
      } = this.props;
      selectFolder(folderId, parentFolderId, isMultiselect);
    };

    this.setDragOverTimeout = () => {
      this.__dragOverTimeout = setTimeout(this.handleDragOverOpenChange, DRAG_OVER_TIMEOUT);
    };

    this.clearDragOverTimeout = () => {
      if (this.__dragOverTimeout) {
        clearTimeout(this.__dragOverTimeout);
      }
    };

    this.handleDragOverOpenChange = () => {
      this.handleOpenChange(true);
    };

    this.handleOpenChange = open => {
      const {
        fetchContents,
        folderId,
        isFetchingContents,
        toggleOpenFolder
      } = this.props;
      toggleOpenFolder(folderId, open);

      if (open && isFetchingContents === null) {
        fetchContents(folderId);
      }
    };

    this.handleRenameCancel = () => {
      this.props.toggleRenameFolder();
    };

    this.handleRenameConfirm = renameValue => {
      this.props.renameFolder(renameValue);
      this.props.toggleRenameFolder();
    };

    this.handleClick = evt => {
      evt.stopPropagation();
      const {
        folderId,
        isActive,
        shiftSelectAsset
      } = this.props;

      if (hasShiftKey(evt)) {
        shiftSelectAsset(folderId);
      } else {
        this.handleSelectFolder(hasCommandKey(evt));
      }

      if (hasCommandKey(evt) || hasShiftKey(evt)) {
        evt.preventDefault();
        return;
      }

      if (this.props.isThemeFolder) {
        if (this.props.activeThemeFolderId === folderId) {
          // Don't change open state when in theme view.
          // Doing so will collapse sub-folders.
          return;
        } else {
          this.props.setActiveThemeFolderId(folderId);
        }
      }

      const {
        open
      } = this.state;

      if (isActive || !open) {
        this.setState({
          open: !open
        });
      }
    };

    this.handleOpenContextMenu = (...args) => {
      const {
        isSelected
      } = this.props;

      if (!isSelected) {
        this.handleSelectFolder(false);
      }

      this.props.openContextMenu(...args);
    };

    this.scrollIntoView = () => {
      const folderNode = findDOMNode(this);

      if (folderNode) {
        this.scrollTimeout = setTimeout(() => {
          folderNode.scrollIntoView();
        }, 0);
      }
    };

    this.renderProjectTooltip = folderName => {
      return /*#__PURE__*/_jsx(Fragment, {
        children: /*#__PURE__*/_jsx(UITooltip, {
          headingText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('headingText')
          }),
          use: "longform",
          placement: "right",
          title: /*#__PURE__*/_jsxs(Fragment, {
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('text')
            }), ' ', /*#__PURE__*/_jsx(UILink, {
              href: `/developer-projects/${PortalIdParser.get()}/project/${folderName}`,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('linkText')
              })
            })]
          }),
          children: /*#__PURE__*/_jsx("span", {
            style: {
              color: OBSIDIAN
            },
            children: folderName
          })
        })
      });
    };

    this.renderIcon = () => {
      const {
        isThemeFolder,
        isLocked,
        isAncestorLocked,
        isServerlessFunctionFolder,
        isProjectFolder,
        isHubspotRootFolder,
        isMarketplaceRootFolder,
        folder
      } = this.props; //  Context for using render props:
      //  https://git.hubteam.com/HubSpot/UIComponents/pull/7442

      return props => /*#__PURE__*/_jsx(FolderIcon, Object.assign({
        open: this.state.open,
        isThemeFolder: isThemeFolder,
        isLocked: isLocked,
        isAncestorLocked: isAncestorLocked,
        isServerlessFunctionFolder: isServerlessFunctionFolder,
        isProjectFolder: isProjectFolder,
        isHubspotRootFolder: isHubspotRootFolder,
        isMarketplaceRootFolder: isMarketplaceRootFolder,
        isReadOnly: folder.readOnly
      }, props));
    };

    this.renderTitle = () => {
      const {
        folderName,
        isLocked,
        isAncestorLocked,
        isHubspotRootFolder,
        isMarketplaceRootFolder,
        isProjectFolder,
        folder
      } = this.props;

      if (folder.readOnly || isHubspotRootFolder || isMarketplaceRootFolder) {
        return /*#__PURE__*/_jsx("span", {
          style: {
            color: OBSIDIAN
          },
          children: folderName
        });
      } else if (isLocked || isAncestorLocked) {
        return /*#__PURE__*/_jsx("i", {
          style: {
            color: EERIE
          },
          children: folderName
        });
      } else if (isProjectFolder) {
        return this.renderProjectTooltip(folderName);
      } else {
        return folderName;
      }
    };

    this.renderNotEditableIcon = () => {
      const {
        isHubspotRootFolder,
        isMarketplaceRootFolder
      } = this.props;

      if (isHubspotRootFolder || isMarketplaceRootFolder) {
        return /*#__PURE__*/_jsx(UneditableIcon, {
          name: "notEditable",
          screenReaderText: "Uneditable icon",
          style: {
            color: BUTTON_DISABLED_TEXT
          },
          size: "small"
        });
      }

      return null;
    };
  }

  componentDidMount() {
    const {
      fetchContents,
      folderId,
      initialOpen,
      isFetchingContents,
      isActive,
      isRevealedAsset
    } = this.props;

    if (initialOpen && isFetchingContents === null) {
      fetchContents(folderId);
    }

    this.props.connectDragPreview(getEmptyImage(), {
      captureDraggingState: true
    });

    if (isActive) {
      this.handleSelectFolder();
    }

    if (isRevealedAsset) {
      this.scrollIntoView();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      canDrop,
      initialOpen,
      isOver,
      onUpdateCanDrop,
      isRevealedAsset
    } = prevProps;
    const {
      initialOpen: nextOpen,
      isOver: nextIsOver,
      isRevealedAsset: nextIsRevealedAsset
    } = this.props;

    if (prevState.open !== this.state.open) {
      this.handleOpenChange(this.state.open);
    }

    if (!isRevealedAsset && nextIsRevealedAsset) {
      this.scrollIntoView();
    }

    if (isRevealedAsset) this.props.revealInFinder(null);

    if (initialOpen !== nextOpen) {
      this.setState({
        open: nextOpen
      });
    }

    if (isOver !== nextIsOver) {
      if (nextIsOver) {
        onUpdateCanDrop(canDrop);

        if (canDrop) {
          this.setDragOverTimeout();
        }
      } else {
        this.clearDragOverTimeout();
      }
    }

    if (this.props.isActive && !this.props.isSelected) {
      this.handleSelectFolder();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.scrollTimeout);
    this.props.closeContextMenu();
  }

  renderFolderContents() {
    if (this.props.hideChildren) {
      return null;
    }

    const {
      folder,
      folderContents,
      folderContentsOrder,
      folderId,
      folderName,
      isAncestorLocked,
      isDragging,
      isHubspotRootFolder,
      isLocked,
      isMarketplaceRootFolder,
      isParentDragging,
      onUpdateCanDrop,
      closeContextMenu,
      openContextMenu
    } = this.props;
    const {
      files,
      subfolders,
      uploading
    } = folderContents;
    const childProps = {
      parentFolderId: folderId,
      parentFolderName: folderName
    };
    return folderContentsOrder.map(childId => {
      if (files.includes(childId)) {
        return /*#__PURE__*/_createElement(FileNode, Object.assign({}, childProps, {
          "data-finder-node-id": childId,
          fileId: childId,
          key: childId,
          closeContextMenu: closeContextMenu,
          openContextMenu: openContextMenu,
          isInLockedFolder: isLocked || isAncestorLocked
          /* Optimization to avoid expensive selector calls from descendants */
          ,
          isInSystemFolder: isHubspotRootFolder || isMarketplaceRootFolder,
          isReadOnly: folder.readOnly
        }));
      }

      if (subfolders.includes(childId)) {
        // Hide theme folder children in root view
        const hideChildren = this.props.isRootFolder && this.props.evaluateIsThemeRootFolder(childId);
        return /*#__PURE__*/_createElement(FolderNode, Object.assign({}, childProps, {
          "data-finder-node-id": childId,
          folderId: childId,
          isParentDragging: isDragging || isParentDragging,
          key: childId,
          onUpdateCanDrop: onUpdateCanDrop,
          closeContextMenu: closeContextMenu,
          openContextMenu: openContextMenu,
          isAncestorLocked: isLocked || isAncestorLocked
          /* Optimization to avoid expensive selector calls from descendants */
          ,
          hideChildren: hideChildren
        }));
      }

      if (uploading.includes(childId)) {
        return /*#__PURE__*/_jsx(FileUploadNode, {
          folderId: folderId,
          fileName: childId
        }, childId);
      }

      return null;
    });
  }

  render() {
    if (!this.props.folder) {
      return null;
    }

    const {
      canDrop,
      folderId,
      folderName,
      isDragging,
      isOver,
      isRootFolder,
      isSelected,
      itemClassName,
      showRenameFolderConfirm,
      isThemeFolder,
      isProjectFolder,
      activeThemeFolderId,
      activeProjectFolderId
    } = this.props;
    const {
      open
    } = this.state;
    const renderedContents = this.renderFolderContents();
    const itemClasses = classNames('folder-item', itemClassName, isRootFolder && 'is--root-folder', isThemeFolder && 'is--theme-folder', isProjectFolder && 'is--project-folder', canDrop && 'can--drop', isDragging && 'is--dragging', isOver && 'is--over', isSelected && 'is--selected');

    const _this$props = this.props,
          {
      connectDragSource
    } = _this$props,
          passDownProps = _objectWithoutPropertiesLoose(_this$props, ["connectDragSource"]);

    const renderProps = Object.assign({}, passDownProps, {
      _connectDragSource: connectDragSource,
      active: isSelected,
      iconLeft: this.renderIcon(),
      iconRight: this.renderNotEditableIcon(),
      itemClassName: itemClasses,
      linkComponent: FolderTitle,
      onClick: this.handleClick,
      openContextMenu: this.handleOpenContextMenu,
      onRenameCancel: this.handleRenameCancel,
      onRenameConfirm: this.handleRenameConfirm,
      showRenameConfirm: showRenameFolderConfirm,
      title: this.renderTitle(),
      value: folderId,
      onDragOverOpenChange: this.handleDragOverOpenChange,
      open
    });

    if (isThemeFolder || isProjectFolder) {
      Object.assign(renderProps, {
        canDrag: false,
        _connectDragSource: emptyFunction,
        onDragOverOpenChange: emptyFunction,
        open: activeThemeFolderId === folderId || activeProjectFolderId === folderId
      });
    }

    return /*#__PURE__*/_jsx(DraggableFolderNavItem, Object.assign({}, renderProps, {
      "data-test-path": this.props.folder.fullPath,
      "data-test-folder-open": open ? 'true' : 'false',
      "data-finder-node-name": folderName,
      children: renderedContents
    }));
  }

}, _class.propTypes = {
  asLink: PropTypes.bool,
  bulkPermissions: FinderPropTypes.bulkPermissions.isRequired,
  canDrop: PropTypes.bool,
  canMoveSelectedAssets: PropTypes.bool.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  fetchContents: PropTypes.func.isRequired,
  fetchContentsError: PropTypes.instanceOf(Error),
  folder: FolderPropTypes.folder,
  folderContents: PropTypes.shape({
    files: PropTypes.arrayOf(FinderPropTypes.assetId),
    subfolders: PropTypes.arrayOf(FinderPropTypes.assetId),
    uploading: PropTypes.arrayOf(FinderPropTypes.assetId)
  }).isRequired,
  folderContentsOrder: PropTypes.arrayOf(FinderPropTypes.assetId),
  folderId: FolderPropTypes.folderId.isRequired,
  folderName: FolderPropTypes.folderName,
  folderSubcategory: FolderPropTypes.folderSubcategory,
  hideChildren: PropTypes.bool,
  initialOpen: PropTypes.bool,
  isActive: PropTypes.bool.isRequired,
  isAncestorLocked: PropTypes.bool,
  isDragging: PropTypes.bool,
  isFetchingContents: PropTypes.bool,
  isLocked: PropTypes.bool,
  isOver: PropTypes.bool,
  isParentDragging: PropTypes.bool,
  isRevealedAsset: PropTypes.bool.isRequired,
  isHubspotRootFolder: PropTypes.bool.isRequired,
  isMarketplaceRootFolder: PropTypes.bool,
  isRootFolder: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isServerlessFunctionFolder: PropTypes.bool.isRequired,
  isProjectFolder: PropTypes.bool,
  isThemeFolder: PropTypes.bool.isRequired,
  isUserFolder: FolderPropTypes.isUserFolder,
  itemClassName: PropTypes.string,
  moveContents: PropTypes.func.isRequired,
  moveSelectedAssets: PropTypes.func.isRequired,
  onUpdateCanDrop: PropTypes.func,
  parentFolderId: FolderPropTypes.folderId,
  renameFolder: PropTypes.func.isRequired,
  revealInFinder: PropTypes.func.isRequired,
  selectFolder: PropTypes.func.isRequired,
  shiftSelectAsset: PropTypes.func.isRequired,
  showRenameFolderConfirm: PropTypes.bool,
  toggleOpenFolder: PropTypes.func.isRequired,
  toggleRenameFolder: PropTypes.func.isRequired,
  closeContextMenu: PropTypes.func.isRequired,
  openContextMenu: PropTypes.func.isRequired,
  setActiveThemeFolderId: PropTypes.func.isRequired,
  setActiveProjectFolderId: PropTypes.func.isRequired,
  activeThemeFolderId: FinderPropTypes.FolderPropTypes.folderId,
  activeProjectFolderId: FinderPropTypes.FolderPropTypes.folderId,
  evaluateIsThemeRootFolder: PropTypes.func.isRequired
}, _class.defaultProps = {
  asLink: true,
  canDrop: false,
  fetchContentsError: null,
  folderContents: {
    files: [],
    subfolders: [],
    uploading: [],
    order: []
  },
  folderContentsOrder: [],
  folderName: '',
  folderSubcategory: null,
  hideChildren: false,
  initialOpen: false,
  isAncestorLocked: false,
  isDragging: false,
  isFetchingContents: null,
  isOver: false,
  isParentDragging: false,
  onUpdateCanDrop: emptyFunction,
  showRenameFolderConfirm: true
}, _temp));
export default FolderNode;